import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pagination } from '@classes/pagination/pagination';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import { PaginationResp } from '@classes/pagination/paginationResp';
import { RecordsCoudPouce } from '@classes/records/record';
import { environment } from '@environments/environment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import * as FileSaver from 'file-saver';
import { ExportExcelFileService } from '@services/export-excel/export-excel-file.service';


@Injectable({
  providedIn: 'root'
})
export class RecordsService {

  lastQuery = null;
  recordsListChanged = new Subject<RecordsCoudPouce[]>();
  eventsListSubject = new BehaviorSubject<PaginationResp>(null);

  paginationRecordsSubject = new BehaviorSubject<Pagination>(null);
  private recordsList: RecordsCoudPouce[] = [];

  constructor(
    private http: HttpClient,
    private exportExcelService: ExportExcelFileService
  ) { }

  /* ----------------------------------- GET ---------------------------------- */


  getRecords(request: PaginationRequest) {
    let httpParams = new HttpParams();

    if (request.query) {
      const filters = request.query;
      const filtersQuery = [];

      if (filters.step) {
        filtersQuery.push(`step==${filters.step.id}`);
      }
      if (filters.type) {
        filtersQuery.push(`type==${filters.type}`);
      }
      if (filters.category) {
        const idCategory = '';
        filtersQuery.push(`category==${filters.category}`);
      }
      // if (filters.subCategory) {
      //   const idSubCategory = '';
      //   filtersQuery.push(`category==${filters.category.id}`);
      // }
      if (filters.username) {
        filtersQuery.push(`createdBy@=${filters.username}`);
      }
      if (filters.dateFrom && filters.dateTo) {
        filtersQuery.push(`createdOn>=${filters.dateFrom},createdOn<=${filters.dateTo}`);
      }

      this.lastQuery = request.query;

      httpParams = httpParams.append('filters', filtersQuery.join());

    } else {
      this.lastQuery = null;
    }

    if (request.pageSize && request.includeCount && request.page) {
      httpParams = httpParams
        .append('pageSize', request.pageSize.toString())
        .append('page', request.query !== this.lastQuery ? '1' : request.page.toString());
    }

    if (request.sort) {
      httpParams = httpParams.append('sorts', request.sort);
    }

    this.http.get(`${environment.apiUrl}/records`, { params: httpParams, observe: 'response', headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` } })
      .subscribe((result: HttpResponse<any[]>) => {
        this.recordsList = result.body;

        const eventsList = new PaginationResp(result.body, result.headers.get('x-pagination'));
        this.eventsListSubject.next(eventsList);

      });
  }



  exportRecords(request: PaginationRequest) {
    let httpParams = new HttpParams();

    if (request.query) {
      const filters = request.query;
      const filtersQuery = [];

      if (filters.step) {
        filtersQuery.push(`step==${filters.step.id}`);
      }
      if (filters.category) {
        const idCategory = '';
        filtersQuery.push(`category==${filters.category.id}`);
      }
      if (filters.subCategory) {
        const idSubCategory = '';
        filtersQuery.push(`category==${filters.category.id}`);
      }
      if (filters.username) {
        filtersQuery.push(`createdBy@=${filters.username}`);
      }
      if (filters.dateFrom && filters.dateTo) {
        filtersQuery.push(`createdOn>=${filters.dateFrom},createdOn<=${filters.dateTo}`);
      }

      this.lastQuery = request.query;

      httpParams = httpParams.append('filters', filtersQuery.join());

    } else {
      this.lastQuery = null;
    }

    if (request.pageSize && request.includeCount && request.page) {
      httpParams = httpParams
        .append('pageSize', request.pageSize.toString())
        .append('page', request.query !== this.lastQuery ? '1' : request.page.toString());
    }

    if (request.sort) {
      httpParams = httpParams.append('sorts', request.sort);
    }

    this.http.get(`${environment.apiUrl}/records/xlsx`, { params: httpParams, observe: 'response', responseType: 'blob', headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` } })
      .subscribe((res) => {
        this.saveFile(res);
      });
  }


  private saveFile(res: HttpResponse<Blob>): Blob {
    const date = new Date().toISOString();

    const title = 'redords_coudpouce' + date + '.xlsx';
    // FileSaver.saveAs(res.body, res.headers.get('filename'));
    FileSaver.saveAs(res.body, title);
    return res.body;
  }


  /* -------------------------------------------------------------------------- */


  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */


  resetAllRecords() {
    return this.http.post(`${environment.apiUrl}/records/reset`, null, {
      headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` }
    });
  }

  /* -------------------------------------------------------------------------- */
  /*                                   DELETE                                   */
  /* -------------------------------------------------------------------------- */

  deleteRecord(id: string) {
    return this.http.delete(`${environment.apiUrl}/records/${id}`, {
      headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` }
    });
  }
}
